import React, { useEffect, memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import get from "lodash/get";
import { fetchOrderDetails, setData } from "ducks/actions";
import { urlParam, isMobile } from "utils/helpers";
import {
  makeSelectSelfActivationDeliveryOrder,
  makeSelectDeliveryLocation
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";

const SelfActivationDeliverySuccess = Component =>
  function Comp(props) {
    const { hideModal, triggerSadPurchaseSuccessEvent } = props;
    useEffect(() => {
      triggerSadPurchaseSuccessEvent();
    }, [triggerSadPurchaseSuccessEvent]);
    useEffect(() => {
      hideModal();
    }, [hideModal]);
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  order: makeSelectSelfActivationDeliveryOrder(),
  isMobile: () => isMobile(),
  deliveryLocation: makeSelectDeliveryLocation()
});

export function mapDispatchToProps(dispatch) {
  return {
    fetchOrderDetails: () => {
      dispatch(fetchOrderDetails({ order_ref: urlParam("order_ref") }));
    },
    triggerSadPurchaseSuccessEvent: () => {
      dispatch(
        setData({
          key: "sadPurchaseSuccess",
          data: { sadPurchaseSuccess: true }
        })
      );
    },
    hideModal: () => {
      dispatch(
        setData({
          key: "showOrderInfoModal",
          data: { success: false, loading: false }
        })
      );
    }
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  messageData: {
    delivery_slot: get(stateProps, "order.delivery_slot"),
    address: get(stateProps, "deliveryLocation"),
    order_ref: get(stateProps, "order.order_ref"),
    iccid: get(stateProps, "order.iccid"),
    self_activation_url: `/self_activation/${
      get(stateProps, "order.is_esim_sim_type") ? "esim" : "psim"
    }?reset=true&iccid=${get(stateProps, "order.iccid") || ""}`,
    manage_order_url: get(stateProps, "order.manage_order_url"),
    authorize_url: get(stateProps, "order.authorise_others_url"),
    predelivery_url: get(stateProps, "order.predelivery_changes_url"),
    sim_count: get(stateProps, "order.family_plan_sim_count"),
    pop_station_pickup_point: get(
      stateProps,
      "order.delivery_address.outlet_name"
    )
  }
});

SelfActivationDeliverySuccess.defaultProps = {
  fetchOrderDetails: () => {}
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  memo
)(SelfActivationDeliverySuccess(SmartRender));
